<template>
  <div>
    <BlDialogMv
      :active="isActive"
      title="Yah, saldo gak cukup"
      confirm-text="Isi saldo"
      dismiss-text="Nanti saja"
      data-test-top-up-dialog
      @confirmClick="redirectToTopUpPage"
      @dismissClick="$emit('dismiss-clicked')"
    >
      <div slot="description">
        <BlTextAv class="mb-24">
          Total saldo kamu gak cukup untuk bayar transaksi ini.
        </BlTextAv>
      </div>
    </BlDialogMv>
  </div>
</template>

<script>
import BlTextAv from '@bukalapak/bazaar-mweb/dist/components/BlTextAv';
import BlDialogMv from '@bukalapak/bazaar-mweb/dist/components/BlDialogMv';

export default {
  name: 'InsufficientBalanceDialog',
  components: {
    BlDialogMv,
    BlTextAv,
  },
  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  methods: {
    redirectToTopUpPage() {
      this.$emit('redirect-to-top-up-page');
    },
  },
};
</script>
